import { QueryKey } from '@tanstack/react-query';
import { matchRoutePattern } from '@/ws/fallback/matchRoutePattern';
import { WsFallbackConfig } from '@/ws/fallback/types';

export function resolveRouteQueries(config: WsFallbackConfig, pathname: string): QueryKey[] {
  const matched = matchRoutePattern(config.routeQueries, pathname);

  let routeQueries: readonly QueryKey[] = [];
  if (matched) {
    routeQueries = typeof matched.entry === 'function' ? matched.entry(matched.params) : matched.entry;
  }

  return [...routeQueries, ...(config.alwaysOnQueries ?? [])];
}
